import { render, staticRenderFns } from "./LoopItemPanel.vue?vue&type=template&id=0b67f8bc&scoped=true&"
import script from "./LoopItemPanel.vue?vue&type=script&lang=js&"
export * from "./LoopItemPanel.vue?vue&type=script&lang=js&"
import style0 from "./LoopItemPanel.vue?vue&type=style&index=0&id=0b67f8bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b67f8bc",
  null
  
)

export default component.exports